// extracted by css-extract-rspack-plugin
module.exports =  {"inventoryCount":"InventoryManagerHeader__inventoryCount___parKW"};